import React, { useState, useCallback, memo, useEffect } from "react";
import moment from "moment";

const KnowledgeBaseComponent = memo(({
  items = [],
  noItemsMessage = "No Knowledge Base added.",
  id,
  DefaultContactID
}) => {
  console.log('check ID::',id);
  console.log('check Default ID::',DefaultContactID);
  
  const [isOpen, setIsOpen] = useState(false);
  
 useEffect(() => {
    const checkScreenSize = () => {
      const isLaptopScreen = window.matchMedia('(min-width: 992px) and (max-width: 1599px)').matches;
      const shouldOpen = isLaptopScreen && id && DefaultContactID && id.toString() !== DefaultContactID.toString();
      
      if (shouldOpen) {
        setIsOpen(true);
      } else {
        const isSmallScreen = window.matchMedia('(max-width: 992px)').matches;
        const isLargeScreen = window.matchMedia('(min-width: 1600px)').matches;
        setIsOpen(isSmallScreen || isLargeScreen);
      }
    };
    
    checkScreenSize();
    window.addEventListener('resize', checkScreenSize);
    return () => window.removeEventListener('resize', checkScreenSize);
  }, [id, DefaultContactID]);


  const toggleAccordion = useCallback(() => {
    setIsOpen(prev => !prev);
  }, []);

  const renderItem = useCallback((item, index) => (
    <div
      key={item.ID || index}
      style={{
        border: "1px solid #ddd",
        borderRadius: "4px",
        padding: "6px",
        marginBottom: "10px",
        display: "flex",
        justifyContent: "space-between",
        alignItems: "flex-start",
      }}
    >
      <div style={{ width: "75%" }}>
        <p style={{ fontSize: "12px", margin: 0, padding: 0 }}>
          <a
            href={item?.FilePath}
            target="_blank"
            rel="noopener noreferrer"
            style={{ textDecoration: "none", color: "blue" }}
          >
            <strong style={{ fontSize: "inherit" }}>
              {item?.Name || ""}
            </strong>
          </a>{" "}
          has been uploaded by {item?.UploaderName || ""}
        </p>
      </div>

      <div style={{ width: "25%", textAlign: "right" }}>
        <p className="m-0" style={{ fontSize: "8px", color: "gray" }}>
          {item?.CreatedDate
            ? moment(item?.CreatedDate).format("MMM D | hh:mm a")
            : ""}
        </p>
      </div>
    </div>
  ), []);

  return (
    <div className="col-md-12 mt-2">
      <div className="empProfile-accordion">
        <div
          className="OfficialInfo-header"
          onClick={toggleAccordion}
          style={{ cursor: "pointer" }}
        >
          <h6 className="mb-0 d-flex align-items-center">Knowledge Base</h6>
          <span>
            <i
              className={`bi bi-arrow-${
                isOpen ? "up" : "down"
              }-circle-fill icon-acc`}
            ></i>
          </span>
        </div>

        {isOpen && (
          <div className="knowledgeInfo-body p-2">
            {Array.isArray(items) && items.length > 0 ? (
              items.map(renderItem)
            ) : (
              <div
                style={{
                  border: "1px solid #ddd",
                  borderRadius: "4px",
                  padding: "10px",
                  textAlign: "center",
                }}
              >
                <p className="text-muted m-0" style={{ fontSize: "12px" }}>
                  {noItemsMessage}
                </p>
              </div>
            )}
          </div>
        )}
      </div>
    </div>
  );
});

export default KnowledgeBaseComponent;